// various
import { computed, ComputedRef } from 'vue'
import * as _ from 'lodash'

// model
import BookingData from '@/classes/BookingData'
import APIResponses, { IAPIResponses } from '@/classes/APIResponses'
import { IServiceFamily } from '@/model/ServiceFamily/ServiceFamily'

// compossables
import processAccomodations from '@/computed/bookingData/processAccomodations'
import processServices from '@/computed/bookingData/processServices'
import processInsurances from '@/computed/bookingData/processInsurances'
import processFunnelConfig from '@/computed/bookingData/processFunnelConfig'
import processLihe from '@/computed/bookingData/processLihe'
import processTravellers from '@/computed/bookingData/processTravellers'
import processFees from '@/computed/bookingData/processFees'
import processDiscounts from '@/computed/bookingData/processDiscounts'

// state
import funnelConfig from '@/state/funnelConfig'
import priceResponse from '@/state/priceResponse'
import bookingQuoteResponse from '@/state/bookingQuoteResponse'
import serviceFamiliesContentResponse from '@/state/serviceFamiliesContentResponse'
import serviceContentResponse from '@/state/serviceContentResponse'
import liheContentResponse from '@/state/liheContentResponse'
import { QuoteState } from '../../../requests-module/src'
import bookingQuoteResponse_edit from '@/state/bookingQuoteResponse_edit'

const isHaveResponses = (responses: IAPIResponses) => {
    if (!responses.bookingQuoteResponse) return false
    if (!responses.serviceFamiliesContentResponse) return false
    if (!responses.liheContentResponse) return false
    // if (!responses.priceResponse) return false
    return true
}

const getBookingData = (source: 'state' | 'booking' = 'state', currentOrEdit: "current" | "edit" = "current"): BookingData => {
    const bookingQuote = currentOrEdit === "current" ? bookingQuoteResponse.value : bookingQuoteResponse_edit.value

    // extract relevant API responses
    const responses: IAPIResponses = new APIResponses(
        funnelConfig.value,
        priceResponse.value,
        bookingQuote,
        serviceFamiliesContentResponse.value,
        serviceContentResponse.value,
        liheContentResponse.value
    )

    // init bookingData
    const bookingData: BookingData = new BookingData(responses)

    // if not all mandatory API responses present - return bookingData with empty objects
    if (!isHaveResponses(responses)) return bookingData

    const sourceObj: QuoteState | null | undefined = bookingData.responses.bookingQuoteResponse![source]
    if (!sourceObj) return bookingData

    // process data (order matters, because some things need to exist before processing other things)
    processLihe(bookingData, sourceObj)
    if (responses.funnelConfig) processFunnelConfig(bookingData)
    
    processTravellers(bookingData, sourceObj) // create traveller objects
    processFees(bookingData, sourceObj) // create fee objects
    processAccomodations(bookingData, sourceObj) // create accomodation objects and connect to travellers
    processServices(bookingData, sourceObj) // create service families and services and connect to travellers and accomodations
    processInsurances(bookingData, sourceObj) // create insurance families and insurances and connect to travellers and accomodations
    processDiscounts(bookingData, sourceObj) // fill discounts array with Discount objects
    
    bookingData.commercialDiscount = sourceObj.commercialDiscount
    bookingData.totalPrice = sourceObj.totalPrice
    bookingData.packagePrice = sourceObj.packagePrice

    // return interconnected data
    return bookingData
}

export const quoteOrReservationData: ComputedRef<BookingData> = computed(() => {
    return getBookingData('booking', "current")
})
const bookingData: ComputedRef<BookingData> = computed(() => {
    // probably overkill to have the whole booking data as a computed, because it will trigger all the computations on any change, but whatever, the number of computations isn't that bad
    return getBookingData('state', "current")
})
export const editBookingData: ComputedRef<BookingData> = computed(() => {
    // probably overkill to have the whole booking data as a computed, because it will trigger all the computations on any change, but whatever, the number of computations isn't that bad
    return getBookingData('state', "edit")
})

export default bookingData
